export default __webpack_public_path__ + "static/media/gemini.73eeaeb4.svg";